var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5276 2.78197C17.3274 2.02924 16.7351 1.43543 15.9815 1.23191C14.6189 0.866699 9.15187 0.866699 9.15187 0.866699C9.15187 0.866699 3.68763 0.866699 2.32226 1.23191C1.57145 1.43264 0.979145 2.02646 0.776148 2.78197C0.411865 4.14803 0.411865 7.00003 0.411865 7.00003C0.411865 7.00003 0.411865 9.85203 0.776148 11.2181C0.976364 11.9708 1.56867 12.5646 2.32226 12.7682C3.68763 13.1334 9.15187 13.1334 9.15187 13.1334C9.15187 13.1334 14.6189 13.1334 15.9815 12.7682C16.7323 12.5674 17.3246 11.9736 17.5276 11.2181C17.8919 9.85203 17.8919 7.00003 17.8919 7.00003C17.8919 7.00003 17.8919 4.14803 17.5276 2.78197Z",
    fill: "#FF3000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40553 9.629L11.9466 7.00003L7.40553 4.37106V9.629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSmall);
export default __webpack_public_path__ + "static/media/youtube-small.a7ac43eae6aae18bb72ec48f9559012d.svg";
export { ForwardRef as ReactComponent };